// users/{uid} — doc id is the Firebase Auth uid (see deriveUserId).
//
// Shape mirrors functions/index.js onUserCreate and src/Auth/UpdateProfile.js.

const REQUIRED_PROFILE_FIELDS = Object.freeze([
  'firstName',
  'lastName',
  'neighborhood',
  'bio',
  'phoneNumber',
]);

const isProfileIncomplete = (profile) => {
  if (!profile) return true;
  return REQUIRED_PROFILE_FIELDS.some(
    (field) => !profile[field] || `${profile[field]}`.trim() === ''
  );
};

const isProfileComplete = (profile) => !isProfileIncomplete(profile);

// userProfile sub-object (public, on users/{uid}): profileImage,
// displayName, authProvider ('google' | 'email'), accountCreated,
// neighborhood, firstName, lastName.
//
// Private contact fields (F-07), on users/{uid}/private/contact, readable
// only by the owner or a confirmed-booking counterpart: userEmail, bio,
// phoneNumber. isProfileIncomplete above is checked against the merge of
// both (see functions/bookings.js bookMeal).
//
// Top-level aggregate fields, kept as running sums by the onReviewRatingsWrite
// trigger (functions/ratings.js), rebuildable from scratch via
// scripts/rebuildHostRatings.js:
// hostRatings / guestRatings: { sumCulinaryRating, sumServiceRating,
//   sumCleanlinessRating, sumOverallRating, totalReviews, avgCulinaryRating,
//   avgServiceRating, avgCleanlinessRating, avgOverallRating, lastUpdated }

module.exports = { REQUIRED_PROFILE_FIELDS, isProfileIncomplete, isProfileComplete };
